// #region imports

// --- HS Code
import { DeleteCommand } from "../shared/delete-command";
import { RespondentModel } from "./respondent-model";

// #endregion

export class RespondentDeleteCommand extends DeleteCommand<RespondentModel> {
  constructor(
    target: RespondentModel,
    commandId: number,
    identifier: string
  ) {
    super(target, commandId, identifier);
  }
}
